<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-title>Fees & Notes List</ion-title> -->
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
                <div class="auth-heading">
                    <h1>Fees & Notes List</h1>
                </div>
                <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
            </div>
      <el-table :data="agencyRatesAndNotes" style="width: 100%">
      <el-table-column prop="pharmacyGroup" label="Group" width="280" />
      <el-table-column prop="rate" label="Fee" width="200" />
      <el-table-column  label="Action" width="120">
        <template #default="scope">
          <ion-button class="button_back" @click="editAgencyNotes(scope.row)">
              <ion-icon name="create-outline"></ion-icon>
          </ion-button>
        </template>
      </el-table-column>
      </el-table>
    </div>
    <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
  </div>
</template>
  
<script>

import { addIcons } from "ionicons";
import { arrowBackOutline, createOutline, addCircleOutline } from "ionicons/icons";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

addIcons({
  "arrow-back-outline": arrowBackOutline,
  "create-outline": createOutline,
  "add-circle-outline" : addCircleOutline,
});
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const routeName = $route.name;
    const userData = $store.getters.GET_USER_DATA;
    const agencyRatesAndNotes = userData.agencyRatesAndNotes;

    const editAgencyNotes = (data) => {
      $router.push({
        name: "profile_agency_note",
        params: { id: data.pharmacyGroupId}
      });
    }

    const goBack = () => {
      $router.push({
        name: "profile",
      });

    };

    return {
      goBack,
      routeName,
      agencyRatesAndNotes,
      editAgencyNotes,
    };
  },
};
</script>
  